import { render } from "./CGZMain.vue?vue&type=template&id=1b7011cb&scoped=true"
import script from "./CGZMain.vue?vue&type=script&lang=js"
export * from "./CGZMain.vue?vue&type=script&lang=js"

import "./CGZMain.vue?vue&type=style&index=0&id=1b7011cb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b7011cb"]])

export default __exports__